module.exports = __webpack_public_path__ + "img/icon_akunred.faebf304.png";